<template>
  <h4>Suivi des Contrats</h4>
</template>

<script>
export default {
  name: "SuiviContrats"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/RFA/DashboardGRFA/Details/SuiviContrats.vue